/* eslint-disable max-statements */
/* eslint-disable max-len */
/* eslint-disable dot-notation */
import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import './styles.scss';
import InputDate from '../../commons/inputDates';
import {Button, Confirm, Dimmer, Grid, Loader} from 'semantic-ui-react';
import SelectedCard from '../../commons/selectedCardDates';
import {useDispatch, useSelector} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {dateFormatShortMonth, noTimeZoneFullISODate} from '../../../../common/constants/datesFormat';
import moment from 'moment';
import {scopes} from '../../../../common/permissions/dictionary';
import {getMaxDate, getMinDate, prepareSelected} from '../../../utils/commonUtils';
import RemoveDate from '../../commons/removeDate';

const {
  fetchAddDaysToDateLogistic,
  fetchGetOrdersAmountByDate,
  removeVehiclesPriorization,
  updateOrdersAmountByDate,
} = Actions;

export const stylesModal = {
  'overlay': {
    'background': 'rgba(0, 0, 0, 0.6)',
    'zIndex': 50,
    'padding': '0px',
  },
  'content': {
    'top': '50%',
    'left': '50%',
    'right': 'auto',
    'bottom': 'auto',
    'marginRight': '-50%',
    'transform': 'translate(-50%, -50%)',
    'padding': '0px',
    'overflow': 'visible',
  },
};

const UpdateDatesModal = ({
  selectedData,
  openUpdateDates,
  setOpenUpdateDates,
  updateMyData,
  userType,
}) => {
  const dispatch = useDispatch();
  const {loadingUpdateDates, loadingDeleteDates} = useSelector((state) => state.priorizationDates);
  const [dates, setDates] = useState({
    'MOV': null,
    'HU': null,
    'ACC': null,
    'PDS': null,
    'PDI': null,
  });
  const [linesCount, setLinesCount] = useState({
    'MOV': null,
    'HU': null,
    'ACC': null,
    'PDS': null,
    'PDI': null,
  });
  const [openModal, setOpenModal] = useState(false);

  const handleChange = (key, value) => {
    setDates((dts) => ({...dts, [key]: value}));
    value ? dispatch(
      fetchGetOrdersAmountByDate(
        setLinesCount,
        key,
        moment(value, noTimeZoneFullISODate).format(dateFormatShortMonth).substring(0, 10)
      )) : setLinesCount({...linesCount, [key]: null});
  };

  const updateNextFields = (key, value) => {
    const fieldsToUpdate = [];
    if (key === 'MOV') {
      !dates?.HU && fieldsToUpdate.push(['HU', 1]);
      !dates?.ACC && fieldsToUpdate.push(['ACC', 2]);
      !dates?.PDS && fieldsToUpdate.push(['PDS', 3]);
      !dates?.PDI && fieldsToUpdate.push(['PDI', 4]);
    }
    if (key === 'HU') {
      !dates?.ACC && fieldsToUpdate.push(['ACC', 1]);
      !dates?.PDS && fieldsToUpdate.push(['PDS', 2]);
      !dates?.PDI && fieldsToUpdate.push(['PDI', 3]);
    }
    if (key === 'ACC') {
      !dates?.PDS && fieldsToUpdate.push(['PDS', 1]);
      !dates?.PDI && fieldsToUpdate.push(['PDI', 2]);
    }
    if (key === 'PDS') {
      !dates?.PDI && fieldsToUpdate.push(['PDI', 1]);
    }
    fieldsToUpdate.forEach(([fieldName, sumDays]) => dispatch(
      fetchAddDaysToDateLogistic(value, sumDays, handleChange, fieldName)
    ));
  };

  const handleSave = () => {
    const vehicleArray = prepareSelected(selectedData);
    const reqData = {
      'hunterScheduledDate': dates.HU ? moment(dates.HU, noTimeZoneFullISODate).format(dateFormatShortMonth) : null,
      'pdsScheduledDate': dates.PDS ? moment(dates.PDS, noTimeZoneFullISODate).format(dateFormatShortMonth) : null,
      'accessoriesScheduledDate': dates.ACC ? moment(dates.ACC, noTimeZoneFullISODate).format(dateFormatShortMonth) : null,
      'movementScheduledDate': dates.MOV ? moment(dates.MOV, noTimeZoneFullISODate).format(dateFormatShortMonth) : null,
      'prioritizationDateMod': dates.PDI ? moment(dates.PDI, noTimeZoneFullISODate).format(dateFormatShortMonth) : null,
      'vehicleArray': vehicleArray,
    };
    dispatch(updateOrdersAmountByDate({'data': reqData}));
  };

  const handleRemovePriorization = () => {
    const vehicleArray = prepareSelected(selectedData);
    const reqData = {'vehicleArray': vehicleArray};
    dispatch(removeVehiclesPriorization({'data': reqData}));
    setOpenModal(false);
  };

  useEffect(() => {
    !openUpdateDates && setDates({
      'MOV': null,
      'HU': null,
      'ACC': null,
      'PDS': null,
      'PDI': null,
    });
  }, [openUpdateDates]);
  
  return (
    <>
      <Modal isOpen={openUpdateDates} style={stylesModal}>
        <Dimmer active={loadingUpdateDates || loadingDeleteDates} inverted>
          <Loader />
        </Dimmer>
        <div className='priorization-dates-modal-container'>
          <div className='priorization-dates-modal-container-col1'>
            <h3>
              Líneas seleccionadas
            </h3>
            <div className='priorization-container-mini-cards'>
              <SelectedCard
                data={selectedData}
                labels={{
                  'chassis': 'CHASIS',
                  'dealerName': 'DEALER',
                  'sfx': 'SFX',
                  'model': 'DESC.',
                }}
                updateMyData={updateMyData}
              />
            </div>

          </div>
          <div className='priorization-dates-modal-container-col2'>
            <h3>
              Actualización de fechas
            </h3>
            <div className='priorization-available-title'>
              Disponible
            </div>
            <div className='priorization-container-input-date'>
              <Grid columns={3}>
                <InputDate
                  label={'MOVILIZACIÓN:'}
                  keyValue={'MOV'}
                  value={dates?.MOV}
                  setDate={handleChange}
                  updateNextFields={updateNextFields}
                  linesCount={linesCount.MOV}
                  minDate={getMinDate(dates, 0)}
                  maxDate={getMaxDate(dates, 0)}
                  canWrite={false}
                />
                <InputDate
                  label={'HUNTER:'}
                  keyValue={'HU'}
                  value={dates?.HU}
                  setDate={handleChange}
                  updateNextFields={updateNextFields}
                  linesCount={linesCount.HU}
                  minDate={getMinDate(dates, 1)}
                  maxDate={getMaxDate(dates, 1)}
                  action={
                    <RemoveDate
                      type={{'key': 'DIS', 'value': 'HUNTER'}}
                      data={selectedData}
                    />
                  }
                />
                <InputDate
                  label={'ACCESORIOS:'}
                  keyValue={'ACC'}
                  value={dates?.ACC}
                  setDate={handleChange}
                  updateNextFields={updateNextFields}
                  linesCount={linesCount.ACC}
                  minDate={getMinDate(dates, 2)}
                  maxDate={getMaxDate(dates, 2)}
                  action={
                    <RemoveDate
                      type={{'key': 'ACC', 'value': 'ACCESORIOS'}}
                      data={selectedData}
                    />
                  }
                />
                <InputDate
                  label={'PDS:'}
                  keyValue={'PDS'}
                  value={dates?.PDS}
                  setDate={handleChange}
                  updateNextFields={updateNextFields}
                  linesCount={linesCount.PDS}
                  minDate={getMinDate(dates, 3)}
                  maxDate={getMaxDate(dates, 3)}
                  canWrite={false}
                />
                <InputDate
                  label={'FECHA ENTREGA:'}
                  keyValue={'PDI'}
                  value={dates?.PDI}
                  setDate={handleChange}
                  updateNextFields={updateNextFields}
                  linesCount={linesCount.PDI}
                  minDate={getMinDate(dates, 4)}
                  maxDate={getMaxDate(dates, 4)}
                  canWrite={false}
                />
              </Grid>
            </div>
            <div className='w-100 mt priorization-modal-order-cancel'>
              {userType === scopes.LogisticEdit && (
                <>
                  <Button
                    type="button"
                    primary
                    className="toyota-secondary"
                    size='small'
                    onClick={() => setOpenModal(true)}
                  >
                    Remover priorización
                  </Button>
                  <div className="priorization-v-line" />
                </>
              )}
              <Button
                type="button"
                basic
                className="toyota-secondary"
                size='small'
                onClick={() => setOpenUpdateDates(false)}
              >
                    Cancelar
              </Button>
              <Button
                type="button"
                primary
                className="toyota-secondary"
                size='small'
                onClick={handleSave}
              >
                    Guardar
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Confirm
        size='tiny'
        open={openModal}
        header='¿SEGURO QUE DESEA CONTINUAR?'
        content={'¿DESEA ELIMINAR LA PRIORIZACIÓN DE LOS VEHÍCULOS SELECCIONADOS?'}
        onCancel={() => setOpenModal(false)}
        onConfirm={handleRemovePriorization}
        cancelButton='Cancelar'
        confirmButton="Confirmar"
      />
    </>
  );
};

export default UpdateDatesModal;
